import { render } from "./PostalAddressModal.vue?vue&type=template&id=0e6be3d4"
import script from "./PostalAddressModal.vue?vue&type=script&lang=js"
export * from "./PostalAddressModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__